var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    key: _vm.timer1
  }, [_c("a-form-model", {
    attrs: {
      model: _vm.form
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选择样式")
    }
  }, [_c("div", {
    staticClass: "imgList"
  }, _vm._l(_vm.configureList, function (item, index) {
    return _c("div", {
      key: index,
      class: _vm.form.controlsComponentsMark == item.mark ? "hit" : "",
      on: {
        click: function ($event) {
          return _vm.imgClick(item.mark, item.id);
        }
      }
    }, [_c("img", {
      attrs: {
        src: item.icon
      }
    })]);
  }), 0)]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("其他设置")
    }
  }, [_c("div", [_c("a-checkbox", {
    attrs: {
      checked: _vm.form.isIdentification
    },
    on: {
      change: _vm.changeIdentificationFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("证件识别")) + " ")])], 1), _c("div", [_c("a-checkbox", {
    attrs: {
      checked: _vm.form.isAddInsured
    },
    on: {
      change: _vm.changeInsuredFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加多个被保人")) + " ")])], 1), _vm.form.isAddInsured ? _c("div", [_vm._v(" " + _vm._s(_vm.$t("添加上限")) + " "), _c("a-input-number", {
    attrs: {
      id: "inputNumber",
      min: 2,
      max: 10
    },
    on: {
      blur: _vm.blurFun
    },
    model: {
      value: _vm.form.insuredNum,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuredNum", $$v);
      },
      expression: "form.insuredNum"
    }
  })], 1) : _vm._e(), _c("div", [_c("a-checkbox", {
    attrs: {
      checked: _vm.form.isHiddenClause
    },
    on: {
      change: _vm.changeClausFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("隐藏条款文件")) + " ")])], 1)]), !_vm.form.isHiddenClause ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("条款展示设置")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("展示格式")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "150px"
    },
    on: {
      change: _vm.changeFun
    },
    model: {
      value: _vm.form.format,
      callback: function ($$v) {
        _vm.$set(_vm.form, "format", $$v);
      },
      expression: "form.format"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "pdf"
    }
  }, [_vm._v(" pdf ")]), _c("a-select-option", {
    attrs: {
      value: "text"
    }
  }, [_vm._v(" text ")])], 1)], 1)]), _c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("阅读限制")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "150px"
    },
    on: {
      change: _vm.changeFun
    },
    model: {
      value: _vm.form.limit,
      callback: function ($$v) {
        _vm.$set(_vm.form, "limit", $$v);
      },
      expression: "form.limit"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("下拉到页面底部")) + " ")]), _c("a-select-option", {
    attrs: {
      value: 3
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("强制阅读")) + " ")]), _c("a-select-option", {
    attrs: {
      value: 4
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("勾选同意")) + " ")])], 1)], 1)]), _c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("强制阅读时间")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-input-number", {
    staticStyle: {
      "margin-right": "10px",
      width: "133px"
    },
    attrs: {
      placeholder: _vm.$t("输入限制：单值"),
      min: 1,
      allowClear: "",
      disabled: _vm.form.limit == 3 ? false : true
    },
    on: {
      blur: _vm.blurFun2
    },
    model: {
      value: _vm.form.time,
      callback: function ($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  })], 1)])]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };